import styled, {css} from "styled-components";

export const AccordionContentDefaultBox = styled.div<{isOpen: boolean}>`
    ${props => props.isOpen ? css`
        max-height: 200px;
        transition: max-height 0.3s ease-in-out;
        overflow-y: auto;
    ` : css`
        max-height: 0px;
        overflow: hidden;
    `}

`;
